import { useEffect, useState } from "react"
import { GetProspectiveDetails, GetProspectivePayment } from "../api/application";
import { getCurrentUser } from "../components/services/auth/authService";

const useProspectivePayment = () => {
    const [data, setData] = useState()
    const [staging, setStaging] = useState()
    const [acceptanceStatus, setAcceptanceStatus] = useState()
    const [resultStatus, setResultStatus] = useState()
    const [admission_letterstatus, setadmission_letter] = useState()
    const [medical_feeStatus, setmedical_feeStatus] = useState()
    const [processing_fee, setProcessing_Fee] = useState()
    const [courseChangeStatus, setCourseChangeStatus] = useState()
    const [loading, setLoading] = useState(false);
    const user = getCurrentUser();

    useEffect(() => {
        const getAdmission = async () => {
            setLoading(true);
            try {
              const { data } = await GetProspectivePayment(user.admission_id);
              console.log("Prospective Payments", data);
              setData(data)
              setAcceptanceStatus(data?.acceptance_fee)
              setResultStatus(data?.result_checking_fee)
              setmedical_feeStatus(data?.medical_fee)
              setadmission_letter(data?.admission_letter)
              setProcessing_Fee(data?.processing_fee)
              setCourseChangeStatus(data?.change_of_course)
              setLoading(false);
            } catch (error) {
              setLoading(false);
            }
          };
          getAdmission()
    }, [])

    return {data, acceptanceStatus, resultStatus, courseChangeStatus, medical_feeStatus, processing_fee, admission_letterstatus}
}

export default useProspectivePayment